import React from "react";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {
  FileUpload
} from "../../../../../../components";
import {SectionInput} from "../MainInfo";

const CERTIFICATE_FIELDS = [
  {name: "certificate_stone", title: "Камень (как в сертификате)"},
  {name: "certificate_color", title: "Цвет (как в сертификате)"},
  {name: "certificate_processing", title: "Обработка (как в сертификате)"},
  {name: "certificate_origin", title: "Происхождение (как в сертификате)"},
  {name: "certificate_laboratory", title: "Лаборатория (как в сертификате)"},
];

class Certificates extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {}
  }

  changeForm = (value) => {
    let values = {...this.props.values};
    values.file_ids = value;
    this.props.onChange(values);
  }

  changeField = (name, value) => {
    let values = {...this.props.values};
    values[name] = value;
    this.props.onChange(values);
  }

  render () {
    const {
      values,
      classes
    } = this.props;

    return (
      <Box className={classes.whiteSection}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12}>
            <Typography variant="h3">Сертификаты</Typography>
          </Grid>

          {CERTIFICATE_FIELDS.map((field) => (
            <Grid item xs={12} key={field.name}>
              <SectionInput
                title={field.title}
                value={values[field.name] || ""}
                inputProps={{maxLength: 50}}
                onChange={this.changeField.bind(this, field.name)}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  }
}

const styles = {
  whiteSection: {
    backgroundColor: "white",
    borderRadius: "5px",
    padding: "10px 24px",
    boxSizing: "border-box",
  },
};
Certificates = withStyles(styles)(Certificates);

export default Certificates
